
import XHeader from 'vux/src/components/x-header/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'

import global from '../../../static/js/global.js'
export default {
components: {
XHeader,
LoadMore
},
data(){
return{
content:''
}
},
beforeMount(){
this.$http.get(global.host + 'news/getNewsById?id=' + this.$router.history.current.query.newid).then(function(res){
if(res.body.result){
console.log(res);
this.content = res.body.result.content + "<style>img{widht:100%;max-width:100%;height:auto;}</style>";
}
},function(err){

})
}
}



// WEBPACK FOOTER //
// ./src/components/newComponents/detailNew.vue